import { GigTheme } from '../../types/gig/interfaces';

export const isNonExperientialGigTheme = (gigTheme: GigTheme) => gigTheme === 'nonExperiential';
